import { CompanyAboutUsInterface, CompanyPersonalInfoInterface } from 'constants/interfaces';
import * as Yup from 'yup';

type TranslateFunction = (key: string, params?: Record<string, string>) => string;

export const companyAboutUsInitialValues: CompanyAboutUsInterface = {
	companyCEOName: '',
	companyFoundedYear: null,
	companySize: null,
	companyDescription: '',
};
export const CompanyPersonalInfoInitialValues: CompanyPersonalInfoInterface = {
	companyName: '',
	phoneNumber: '',
	countryCode: '',
	industryId: null,
	countryId: null,
	stateId: null,
	cityId: null,
	websiteLink: '',
	address: '',
};

export const companyAboutUsSchema = (translate: TranslateFunction) =>
	Yup.object().shape({
		companyCEOName: Yup.string()
			.required(translate('Validation.required', { field: translate('Validation.ceoName') }))
			.trim(),

		companyFoundedYear: Yup.date()
			.required(translate('Validation.required', { field: translate('Profile.foundedYear') }))
			.max(
				new Date(),
				translate('Validation.maxDate', {
					field: translate('Profile.foundedYear'),
					max: new Date().toISOString().split('T')[0],
				}),
			)
			.min(
				new Date(1800, 0, 1),
				translate('Validation.minDate', {
					field: translate('Profile.foundedYear'),
					min: '1800-01-01',
				}),
			),
		companySize: Yup.number().required(
			translate('Validation.required', { field: translate('Profile.companySize') }),
		),
		companyDescription: Yup.string()
			.required(translate('Validation.required', { field: translate('Validation.about') }))
			.trim(),
	});

export const companyDetailsSchema = (translate: TranslateFunction) =>
	Yup.object().shape({
		companyName: Yup.string()
			.required(translate('Validation.required', { field: translate('PlaceHolder.companyName') }))
			.trim(),
		phoneNumber: Yup.string()
			.required(translate('Validation.required', { field: translate('PlaceHolder.phone') }))
			.min(5, translate('Validation.phoneNumberMustBeAtleast'))
			.max(
				12,
				translate('Validation.max', { field: translate('PlaceHolder.phone'), number: '12' }),
			),
		countryCode: Yup.string().required(
			translate('Validation.required', { field: translate('Validation.countryCode') }),
		),
		industryId: Yup.number().required(
			translate('Validation.required', { field: translate('Validation.industryId') }),
		),
		countryId: Yup.number().required(
			translate('Validation.required', { field: translate('Validation.countryId') }),
		),
		stateId: Yup.number().required(
			translate('Validation.required', { field: translate('Validation.StateId') }),
		),
		cityId: Yup.number().required(
			translate('Validation.required', { field: translate('Validation.cityId') }),
		),
		websiteLink: Yup.string()
			.required(translate('Validation.required', { field: translate('Validation.websiteLink') }))
			// .url(translate('Validation.url', { field: translate('Validation.websiteLink') }))
			.trim(),
		address: Yup.string().required(
			translate('Validation.required', { field: translate('Resume.address') }),
		),
	});
